export default __webpack_public_path__ + "static/media/blank.e9169fe2.jpg";